// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraAccountLookup } from './Lookup/TerceraAccountLookup';
export class QuickTableAccountLookup extends TerceraAccountLookup {
    constructor(initProps, data, callback, rect) {
        super();
        this._isProcessedCallback = false;
        this.tag = data;
        this.callback = callback;
        this.setBounds(rect.X, rect.Y, rect.Width, rect.Height);
        void this.set('isPosAbsolute', true);
    }
    oncomplete() {
        super.oncomplete();
        const selectedAccount = this.tag.cell.QuickTableEditingInfo.GetDataHandler();
        this.selectItem(selectedAccount.userPin);
        void this.set('visible', true);
        this.setFocus();
    }
    runCallback(account) {
        this._isProcessedCallback = true;
        this.callback(account, this.tag);
    }
    onLostFocus() {
        if (!this.get('isFormShowed')) {
            this.callback(undefined, this.tag);
        }
    }
    closeForm() {
        super.closeForm();
        if (!this._isProcessedCallback) {
            this.onLostFocus();
        }
    }
}
TerceraAccountLookup.extendWith(QuickTableAccountLookup, {
    data: function () {
        return {
            zIndex: 1
        };
    }
});
